import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { 
    monitorFilterTypeState, 
    pageState, 
    teamIdState, 
    challengeIdState 
} from "../monitor/Monitor.state";
import { 
    categoryState, 
    pageState as dashboardPageState, 
    pageSizeState as dashboardPageSizeState, 
    termState as dashboardTermState
} from '../dashboard/Dashboard.state';
import {
    pageState as challengesPageState,
    pageSizeState as challengesPageSizeState,
    openTabState as challengesOpenState,
} from '../organize/Organize.state'
import {
    pageState as teamsPageState,
    pageSizeState as teamsPageSizeState,
} from '../teams/Teams.state'
import { openTabState as designationOpenState } from '../designations/Designation.state';
import { openTabState as npcOpenState } from '../npc/Npc.state';
import { metricState, styleState } from '../monitor/Leaderboard.state';
import { useResetRecoilState } from 'recoil';

const useRouteChange = ({ onRouteChange }) => {
  const location = useLocation();
  const resetTeamState = useResetRecoilState(teamIdState);
  const resetChallengeState = useResetRecoilState(challengeIdState);
  const resetFilterTypeState = useResetRecoilState(monitorFilterTypeState);
  const resetCategoryState = useResetRecoilState(categoryState);
  const resetMonitorPageState = useResetRecoilState(pageState);
  const resetDashboardPageState = useResetRecoilState(dashboardPageState)
  const resetDashboardPageSizeState = useResetRecoilState(dashboardPageSizeState)
  const resetDashboardTermState = useResetRecoilState(dashboardTermState)
  const resetOpenDesignationState = useResetRecoilState(designationOpenState)
  const resetLeaderboardStyleState = useResetRecoilState(styleState)
  const resetLeaderboardMetricState = useResetRecoilState(metricState)
  const resetOpenNpcState = useResetRecoilState(npcOpenState)
  const resetChallengePageState = useResetRecoilState(challengesPageState)
  const resetChallengePageSizeState = useResetRecoilState(challengesPageSizeState)
  const resetChallengeOpenState = useResetRecoilState(challengesOpenState)
  const resetTeamsPageState = useResetRecoilState(teamsPageState)
  const resetTeamsPageSizeState = useResetRecoilState(teamsPageSizeState)
  const doResetStates = useCallback(() => {
    resetTeamState()
    resetChallengeState()
    resetFilterTypeState()
    resetCategoryState()
    resetMonitorPageState()
    resetDashboardPageState()
    resetDashboardPageSizeState()
    resetDashboardTermState()
    resetOpenDesignationState()
    resetLeaderboardStyleState()
    resetLeaderboardMetricState()
    resetOpenNpcState()
    resetChallengePageState()
    resetChallengePageSizeState()
    resetChallengeOpenState()
    resetTeamsPageState()
    resetTeamsPageSizeState()
  }, [
    resetTeamState,
    resetChallengeState,
    resetFilterTypeState,
    resetCategoryState,
    resetMonitorPageState,
    resetDashboardPageState,
    resetDashboardPageSizeState,
    resetDashboardTermState,
    resetOpenDesignationState,
    resetLeaderboardStyleState,
    resetLeaderboardMetricState,
    resetOpenNpcState,
    resetChallengePageState,
    resetChallengePageSizeState,
    resetChallengeOpenState,
    resetTeamsPageState,
    resetTeamsPageSizeState,
  ])
  useEffect(() => {
    // Only handle route change when the search is empty (i.e. user clicks on the side navigation)
    if (location?.search === "") {
        doResetStates()
        onRouteChange && onRouteChange(location)
    }
  }, [location, onRouteChange, doResetStates]);
};

export default useRouteChange